<app-request-details *ngIf="showMoreInformationMessage && !isFormValid"></app-request-details>

<div *ngIf="showMoreInformationMessage && !isFormValid && !isOpenedFromReleaseReport && !isOpenedFromLonghaulReport"
  class="bs-callout bs-callout-info">
  <h4>More Information Required</h4>
  <p>{{moreInfoMessage}}</p>
</div>
<div *ngIf="isOpenedFromLonghaulReport && isRefundWorkflow" class="bs-callout bs-callout-info">
  <h4>Refund Request</h4>
  <div class="request-summary" style="border-bottom:0px!important; margin-bottom: 0px!important;">
    <div class="request-summary-details">
      <label>Request Number:</label>
      <label> {{refundRequestObj?.BaseRequest?.RequestNumber}}</label>
    </div>
    <div class="request-summary-details">
      <label>Request Status:</label>
      <label>{{refundRequestObj?.BaseRequest?.StatusEN}}</label>
    </div>
  </div>
</div>

<!--<div *ngIf="isRefundWorkflow && (isOpenedFromLonghaulReport || isOpenedFromReleaseReport)" class="bs-callout bs-callout-info">-->
<div class="bs-callout bs-callout-info" *ngIf="isRefundWorkflow && !isMoreInfo">
  <h4>Refund PDF</h4>
  <a class="export-link" href="#" (click)="PrintRefundCover($event)">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img"
      width="1.25em" height="1.25em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16">
      <path
        d="M13.156 9.211c-.213-.21-.686-.321-1.406-.331a11.754 11.754 0 0 0-1.69.124c-.276-.159-.561-.333-.784-.542c-.601-.561-1.103-1.34-1.415-2.197c.02-.08.038-.15.054-.222c0 0 .339-1.923.249-2.573a.73.73 0 0 0-.044-.184l-.029-.076c-.092-.212-.273-.437-.556-.425l-.171-.005c-.316 0-.573.161-.64.403c-.205.757.007 1.889.39 3.355l-.098.239c-.275.67-.619 1.345-.923 1.94l-.04.077c-.32.626-.61 1.157-.873 1.607l-.271.144c-.02.01-.485.257-.594.323c-.926.553-1.539 1.18-1.641 1.678c-.032.159-.008.362.156.456l.263.132a.792.792 0 0 0 .357.086c.659 0 1.425-.821 2.48-2.662a24.79 24.79 0 0 1 3.819-.908c.926.521 2.065.883 2.783.883c.128 0 .238-.012.327-.036a.558.558 0 0 0 .325-.222c.139-.21.168-.499.13-.795a.531.531 0 0 0-.157-.271zM3.307 12.72c.12-.329.596-.979 1.3-1.556c.044-.036.153-.138.253-.233c-.736 1.174-1.229 1.642-1.553 1.788zm4.169-9.6c.212 0 .333.534.343 1.035s-.107.853-.252 1.113c-.12-.385-.179-.992-.179-1.389c0 0-.009-.759.088-.759zM6.232 9.961c.148-.264.301-.543.458-.839c.383-.724.624-1.29.804-1.755a5.813 5.813 0 0 0 1.328 1.649c.065.055.135.111.207.166c-1.066.211-1.987.467-2.798.779zm6.72-.06c-.065.041-.251.064-.37.064c-.386 0-.864-.176-1.533-.464c.257-.019.493-.029.705-.029c.387 0 .502-.002.88.095s.383.293.318.333z"
        fill="currentColor" />
      <path
        d="M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 0 1-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 0 0 .5.5H14v9.75z"
        fill="currentColor" />
    </svg>
    <span>Print</span>
  </a>
</div>
<div *ngIf="isOpenedFromLonghaulReport && isRestudyWorkflow" class="bs-callout bs-callout-info">
  <h4>Restudy Request</h4>
  <div class="request-summary" style="border-bottom:0px!important; margin-bottom: 0px!important;">
    <div class="request-summary-details">
      <label>Request Number:</label>
      <label> {{restudyRequestObj?.BaseRequest?.RequestNumber}}</label>
    </div>
    <div class="request-summary-details">
      <label>Request Status:</label>
      <label>{{restudyRequestObj?.BaseRequest?.StatusEN}}</label>
    </div>
  </div>
</div>
<!--<div *ngIf="isRestudyWorkflow && (isOpenedFromLonghaulReport || isOpenedFromReleaseReport)" class="bs-callout bs-callout-info">-->
<div  class="bs-callout bs-callout-info" *ngIf="isRestudyWorkflow && !isMoreInfo &&  !isRestudy_RestudyRequireModifications">

  <h4>Restudy PDF</h4>
  <a class="export-link" href="#" (click)="PrintRestudyCover($event)">
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img"
      width="1.25em" height="1.25em" preserveAspectRatio="xMidYMid meet" viewBox="0 0 16 16">
      <path
        d="M13.156 9.211c-.213-.21-.686-.321-1.406-.331a11.754 11.754 0 0 0-1.69.124c-.276-.159-.561-.333-.784-.542c-.601-.561-1.103-1.34-1.415-2.197c.02-.08.038-.15.054-.222c0 0 .339-1.923.249-2.573a.73.73 0 0 0-.044-.184l-.029-.076c-.092-.212-.273-.437-.556-.425l-.171-.005c-.316 0-.573.161-.64.403c-.205.757.007 1.889.39 3.355l-.098.239c-.275.67-.619 1.345-.923 1.94l-.04.077c-.32.626-.61 1.157-.873 1.607l-.271.144c-.02.01-.485.257-.594.323c-.926.553-1.539 1.18-1.641 1.678c-.032.159-.008.362.156.456l.263.132a.792.792 0 0 0 .357.086c.659 0 1.425-.821 2.48-2.662a24.79 24.79 0 0 1 3.819-.908c.926.521 2.065.883 2.783.883c.128 0 .238-.012.327-.036a.558.558 0 0 0 .325-.222c.139-.21.168-.499.13-.795a.531.531 0 0 0-.157-.271zM3.307 12.72c.12-.329.596-.979 1.3-1.556c.044-.036.153-.138.253-.233c-.736 1.174-1.229 1.642-1.553 1.788zm4.169-9.6c.212 0 .333.534.343 1.035s-.107.853-.252 1.113c-.12-.385-.179-.992-.179-1.389c0 0-.009-.759.088-.759zM6.232 9.961c.148-.264.301-.543.458-.839c.383-.724.624-1.29.804-1.755a5.813 5.813 0 0 0 1.328 1.649c.065.055.135.111.207.166c-1.066.211-1.987.467-2.798.779zm6.72-.06c-.065.041-.251.064-.37.064c-.386 0-.864-.176-1.533-.464c.257-.019.493-.029.705-.029c.387 0 .502-.002.88.095s.383.293.318.333z"
        fill="currentColor" />
      <path
        d="M14.341 3.579c-.347-.473-.831-1.027-1.362-1.558S11.894 1.006 11.421.659C10.615.068 10.224 0 10 0H2.25C1.561 0 1 .561 1 1.25v13.5c0 .689.561 1.25 1.25 1.25h11.5c.689 0 1.25-.561 1.25-1.25V5c0-.224-.068-.615-.659-1.421zm-2.07-.85c.48.48.856.912 1.134 1.271h-2.406V1.595c.359.278.792.654 1.271 1.134zM14 14.75c0 .136-.114.25-.25.25H2.25a.253.253 0 0 1-.25-.25V1.25c0-.135.115-.25.25-.25H10v3.5a.5.5 0 0 0 .5.5H14v9.75z"
        fill="currentColor" />
    </svg>
    <span>Print</span>
  </a>
</div>
<h4 class="sectionTitle" *ngIf="!isFormValid && isShow">Release Form</h4>
<!-- <div *ngIf="isOpenedFromLonghaulReport  && (isRefundWorkflow || isRestudyWorkflow)" class="bs-callout bs-callout-info">
  <h4>Creator</h4>
  <div class="request-summary" style="border-bottom:0px!important; margin-bottom: 0px!important;">
    <div class="request-summary-details">
      <label>Creator Email:</label>
      <ng-container *ngIf="refundRequestObj; else checkRestudy">
        <label>{{ refundRequestObj?.BaseRequest?.CreatedBy }}</label>
      </ng-container>
      <ng-template #checkRestudy>
        <label *ngIf="restudyRequestObj">{{ restudyRequestObj?.BaseRequest?.CreatedBy }}</label>
      </ng-template>
    </div>
  </div>
</div> -->
<div
  *ngIf="isOpenedFromLonghaulReport && rebateRequestLoaded?.RebateFileNumber != null && isCalculated!=true && !isFormValid && newReleaseForm"
  class="bs-callout bs-callout-info">
  <h4>Rebate File Number</h4>
  <p>[{{rebateRequestLoaded?.RebateFileNumber}}]</p>
</div>
<div class="form-container" *ngIf="!isFormValid">
  <form name="releaseRequestForm" [formGroup]="releaseRequestForm" #releaseRequest>
    <tabset #rebateRequestTabs>
      <tab heading="Requester Details">
        <div class="form-container" formGroupName="TabOne" #tabOne>
          <div class="form-section">
            <h4 class="section-title">Requester Details</h4>
            <div class="form-group">
              <label for="txtBaseRequestRequestNumber">Request Number</label>
              <span class="red"> *</span>
              <input type="text" formControlName="BaseRequestRequestNumber" name="BaseRequestRequestNumber"
                id="txtBaseRequestRequestNumber" class="form-control text-uppercase" />
              <div *ngIf="releaseRequestForm?.controls['TabOne']?.controls['BaseRequestRequestNumber']?.invalid"
                class="red">
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['BaseRequestRequestNumber']?.errors?.required">This
                  Field is Required</span>
              </div>
            </div>

            <div class="form-group">
              <label for="txtRebateFileNo">Rebate file no.</label>
              <span class="red"> *</span>
              <input type="text" formControlName="RebateFileNumber" name="RebateFileNumber" id="txtRebateFileNo"
                class="form-control text-uppercase" />
              <div *ngIf="releaseRequestForm?.controls['TabOne']?.controls['RebateFileNumber']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['RebateFileNumber']?.errors?.required">This
                  Field is Required</span>
              </div>
            </div>
            <div class="form-group">
              <label for="txtImoNo">IMO no.</label>
              <span class="red"> *</span>
              <input type="text" formControlName="IMONo" name="IMONo" id="txtImoNo"
                class="form-control text-uppercase" />
              <div *ngIf="releaseRequestForm?.controls['TabOne']?.controls['IMONo']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['IMONo']?.errors?.required">This
                  Field is Required</span>
              </div>
            </div>


            <div class="form-group">
              <label for="txtVesselName">Vessel Name</label>
              <span class="red"> *</span>
              <input type="text" formControlName="VesselName" name="VesselName" id="txtVesselName"
                class="form-control text-uppercase" />
              <div *ngIf="isTabOneSubmitted && releaseRequestForm?.controls['TabOne']?.controls['VesselName']?.invalid"
                class="red">
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['VesselName']?.errors?.required">This
                  Field is Required</span>
              </div>
              <div *ngIf="releaseRequestForm?.controls['TabOne']?.controls['VesselName']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['VesselName']?.errors?.pattern">Please
                  Enter a Valid Vessel Name</span>
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['VesselName']?.errors?.maxlength">This
                  Field can be at most 200 characters</span>
              </div>
            </div>
            <div class="form-group">
              <label for="textCreateddate">Creation date</label>
              <span class="red"> *</span>
              <input type="text" #CreationDateDatepicker="bsDatepicker" bsDatepicker [minDate]='null'
                [bsConfig]="{dateInputForat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off"
                formControlName="BaseRequestCreationDate" name="BaseRequestCreationDate" id="textCreateddate"
                class="form-control text-uppercase" />




              <div *ngIf="releaseRequestForm?.controls['TabOne']?.controls['BaseRequestCreationDate']?.invalid"
                class="red">
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['BaseRequestCreationDate']?.errors?.required">This
                  Field is Required</span>
              </div>
            </div>


            <div class="form-group">
              <label for="txtAgentName">Agent Name</label>
              <span class="red"> *</span>
              <input type="text" formControlName="RequestorName" name="RequestorName" id="txtAgentName"
                class="form-control text-uppercase" />
              <div *ngIf="releaseRequestForm?.controls['TabOne']?.controls['RequestorName']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['RequestorName']?.errors?.required">This
                  Field is Required</span>
              </div>
            </div>
            <!-- Email -->
            <div class="form-group">
              <label for="txtAgentEMail">Agent Email</label>

              <input type="email" formControlName="RequestorEmail" name="RequestorEmail" id="txtAgentEMail"
                class="form-control" />
              <div *ngIf="isTabOneSubmitted &&
                releaseRequestForm?.controls['TabOne']?.controls['RequestorEmail']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['RequestorEmail']?.errors?.required">This
                  Field is Required</span>
              </div>
              <div *ngIf="releaseRequestForm?.controls['TabOne']?.controls['RequestorEmail']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['RequestorEmail']?.errors?.pattern">Please
                  Enter a Valid Email</span>
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['RequestorEmail']?.errors?.maxlength">This
                  Field can be at most 200 characters</span>
              </div>
            </div>
            <!-- Fax -->
            <div class="form-group">
              <label for="txtAgentFax">Agent Fax</label>
              <input type="text" formControlName="RequestorFax" name="RequestorFax" id="txtAgentFax"
                class="form-control" />
              <div *ngIf="isTabOneSubmitted &&
                releaseRequestForm?.controls['TabOne']?.controls['RequestorFax']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['RequestorFax']?.errors?.pattern">Please
                  Enter a Valid Fax Number</span>
              </div>
            </div>
            <div class="form-group">
              <label for="txtName">Principal Name</label>
              <span class="red"> *</span>
              <input type="text" formControlName="PrincipalName" name="PrincipalName" id="txtName"
                class="form-control text-uppercase" />

              <div *ngIf="isTabOneSubmitted &&
                releaseRequestForm?.controls['TabOne']?.controls['PrincipalName']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['PrincipalName']?.errors?.required">This
                  Field is Required</span>
              </div>
              <div *ngIf="releaseRequestForm?.controls['TabOne']?.controls['PrincipalName']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['PrincipalName']?.errors?.pattern">Please
                  Enter a Valid Principal Name</span>
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['PrincipalName']?.errors?.maxlength">This
                  Field can be at most 200 characters</span>
              </div>
            </div>
            <div class="form-group">
              <label for="txtEMail">Principal Email</label>
              <input type="email" formControlName="PrincipalEmail" name="PrincipalEmail" id="txtEMail"
                class="form-control" />
              <div *ngIf="isTabOneSubmitted &&
                releaseRequestForm?.controls['TabOne']?.controls['PrincipalEmail']?.invalid" class="red">

              </div>
              <div *ngIf="releaseRequestForm?.controls['TabOne']?.controls['PrincipalEmail']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['PrincipalEmail']?.errors?.pattern">Please
                  Enter a Valid Email</span>
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['PrincipalEmail']?.errors?.maxlength">This
                  Field can be at most 200 characters</span>
              </div>
            </div>
            <div class="form-group">
              <label for="txtFax">Principal Fax</label>
              <input type="text" formControlName="PrincipalFax" name="PrincipalFax" id="txtFax" class="form-control" />
              <div *ngIf="releaseRequestForm?.controls['TabOne']?.controls['PrincipalFax']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabOne']?.controls['PrincipalFax']?.errors?.pattern">Please
                  Enter a Valid Fax Number</span>
              </div>
            </div>
          </div>
        </div>
        <p class="btns-holder text-right">
          <button type="button" class="btn  SCAcustomBtn" (click)="selectTab(1)">{{ 'FRONT_USER.NEXT' |
            translate}}</button>
        </p>
      </tab>
      <tab heading="Measurement Data">
        <div class="form-container" formGroupName="TabTwo" #TabTwo>
          <div class="form-section">
            <h4 class="section-title">Measurement Data</h4>
            <div class="form-group">
              <label for="txtDWT">DWT</label>
              <span *ngIf="formMode != 3" class="red"> *</span>
              <input type="text" formControlName="DWT" name="DWT" id="txtDWT" maxlength="6" class="form-control" />
              <div *ngIf="isTabTwoSubmitted && releaseRequestForm?.controls['TabTwo']?.controls['DWT']?.invalid"
                class="red">
                <span *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['DWT']?.errors?.required">This
                  Field is Required</span>
              </div>
              <div *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['DWT']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['DWT']?.errors?.pattern">DWT
                  must be (1 to 6) digits</span>
                <span *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['DWT']?.errors?.maxlength">This
                  Field can be at most 50 characters</span>
              </div>
            </div>
            <!-- SCNT -->
            <div class="form-group">
              <label for="txtSCNT">Net Tonnage (SCNT)</label>
              <span *ngIf="formMode != 3" class="red"> *</span>
              <input type="text" formControlName="SCNT" name="SCNT" id="txtSCNT" class="form-control" />
              <div *ngIf="isTabTwoSubmitted && releaseRequestForm?.controls['TabTwo']?.controls['SCNT']?.invalid"
                class="red">
                <span *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['SCNT']?.errors?.required">This
                  Field is Required</span>
              </div>
              <div *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['SCNT']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['SCNT']?.errors?.pattern">Net
                  Tonnage (SCNT) must be (1 to 6) digits and allows (1 to 2) Decimals</span>
                <span *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['SCNT']?.errors?.maxlength">This
                  Field can be at most 50 characters</span>
              </div>
            </div>
            <div class="form-group">
              <label for="ddlRateId">Rate</label>
              <span class="red"> *</span>
              <select formControlName="AcceptDataRateId" class="form-control" id="ddlRateId" name="AcceptDataRateId">
                <option value="" selected>Choose</option>
                <option *ngFor="let rate of rates" [value]="rate?.Id">
                  {{rate?.NameEN}}
                </option>
              </select>
              <div *ngIf="isTabTwoSubmitted &&
                releaseRequestForm?.controls['TabTwo']?.controls['AcceptDataRateId']?.invalid" class="red">
                <div *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['AcceptDataRateId']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="txtExtraCost">Extra Cost</label>
              <input type="text" formControlName="ExtraCost" name="ExtraCost" id="txtExtraCost" class="form-control" />
              <div *ngIf="isTabTwoSubmitted && releaseRequestForm?.controls['TabTwo']?.controls['ExtraCost']?.invalid"
                class="red">
                <div *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['ExtraCost']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <span *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['ExtraCost']?.errors?.pattern">This
                  Field allows digits only</span>
              </div>
            </div>
            <div class="form-group">
              <label for="dpFormulateDecisionDate">Formulate Decision date</label>
              <span class="red"> *</span>
              <input #FormulateDecisionDateDatepicker="bsDatepicker" bsDatepicker
                formControlName="FormulateDecisionDate" [minDate]='null'
                [bsConfig]="{dateInputForat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off"
                id="dpFormulateDecisionDate" class="form-control" name="FormulateDecisionDate">
              <div *ngIf="isTabTwoSubmitted &&
                releaseRequestForm?.controls['TabTwo']?.controls['FormulateDecisionDate']?.invalid" class="red">
                <div
                  *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['FormulateDecisionDate']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="ddlOptions">Actual voyage</label>
              <span class="red"> *</span>
              <select (change)="onActualVoyageChange($event.target.value)" class="form-control" id="ddlOptions"
                name="Actualvoyage" formControlName="Actualvoyage">
                <option value="" selected>Choose</option>
                <option *ngFor="let longHaulRequestOption of longHaulRequestOptions; let i = index;"
                  [value]="longHaulRequestOption?.Id">
                  ({{lastPortOriginsArr[i]?.Text}} - {{firstPortDestinationsArr[i]?.Text}})
                </option>
              </select>

              <div *ngIf="isTabTwoSubmitted &&
              releaseRequestForm?.controls['TabTwo']?.controls['Actualvoyage']?.invalid" class="red">
                <div *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['Actualvoyage']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="txtOriginPort">Origin port</label>
              <span class="red"> *</span>
              <input (change)="onOriginPortChange()" type="text" formControlName="OriginPort" name="OriginPort"
                id="txtOriginPort" class="form-control" />
              <div *ngIf="isTabTwoSubmitted && releaseRequestForm?.controls['TabTwo']?.controls['OriginPort']?.invalid"
                class="red">
                <div *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['OriginPort']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="txtDestinationPort">Destination port</label>
              <span class="red"> *</span>
              <input (change)="onDestinationPortChange()" type="text" formControlName="DestinationPort"
                name="DestinationPort" id="txtDestinationPort" class="form-control" />
              <div *ngIf="isTabTwoSubmitted &&
                releaseRequestForm?.controls['TabTwo']?.controls['DestinationPort']?.invalid" class="red">
                <div *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['DestinationPort']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="txtRebatePercentage">Rebate Percentage</label>
              <span class="red"> *</span>
              <input type="text" (change)="onRebatePercentageChange()" formControlName="RebatePercentage"
                name="RebatePercentage" id="txtRebatePercentage" class="form-control" />
              <div *ngIf="isTabTwoSubmitted &&
                releaseRequestForm?.controls['TabTwo']?.controls['RebatePercentage']?.invalid" class="red">
                <div *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['RebatePercentage']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <span *ngIf="releaseRequestForm?.controls['TabTwo']?.controls['RebatePercentage']?.errors?.pattern">This
                  Field allows digits only</span>
              </div>
            </div>
          </div>
        </div>
        <p class="btns-holder text-right">
          <button type="button" class="btn SCAcustomBtn" (click)="selectTab(0)">{{ 'FRONT_USER.PREVIOUS' |
            translate}}</button>
          <button type="button" class="btn SCAcustomBtn" (click)="selectTab(2) ">{{ 'FRONT_USER.NEXT' |
            translate}}</button>
        </p>
      </tab>
      <tab heading="Transit Details">
        <div class="form-container" formGroupName="TabThree" #TabThree>
          <div class="form-section">
            <h4 class="section-title">Transit Details</h4>
            <div class="form-group">
              <label for="dpTransitDate"> Transit Date</label>
              <span class="red"> *</span>
              <input #TransitDateDatepicker="bsDatepicker" bsDatepicker formControlName="TransitDate" [minDate]='null'
                [bsConfig]="{dateInputForat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off" id="dpTransitDate"
                class="form-control" name="TransitDate" />
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['TransitDate']?.invalid" class="red">
                <div *ngIf="releaseRequestForm?.controls['TabThree']?.controls['TransitDate']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="ddlTransitRateId">Transit Rate</label>
              <span class="red"> *</span>
              <select (change)="onTransitRateChange($event.target.value)" formControlName="TransitRateId"
                class="form-control" id="ddlTransitRateId" name="TransitRateId">
                <option value="" selected>Choose</option>
                <option *ngFor="let rate of rates" [value]="rate?.Id">
                  {{rate?.NameEN}}
                </option>
              </select>
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['TransitRateId']?.invalid" class="red">
                <div *ngIf="releaseRequestForm?.controls['TabThree']?.controls['TransitRateId']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="ddlVesselTypeId">Vessel Type</label>
              <span class="red"> *</span>
              <select (change)="onVesselTypeChange($event.target.value)" formControlName="VesselTypeId"
                class="form-control" id="ddlVesselTypeId" name="VesselTypeId">
                <option value="" selected>Choose</option>
                <option *ngFor="let vesselType of vesselTypes" [value]="vesselType?.Id">
                  {{vesselType?.NameEN}}
                </option>
              </select>
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['VesselTypeId']?.invalid" class="red">
                <div *ngIf="releaseRequestForm?.controls['TabThree']?.controls['VesselTypeId']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>

            <div class="form-group">
              <label>Vessel's Condition</label>
              <span *ngIf="formMode != 3" class="red"> *</span>
              <div>
                <div class="custom-Radio">
                  <input type="radio" formControlName="IsShipLoaded" id="rbtnIsShipLoadedLaden" value="true" />
                  <label for="rbtnIsShipLoadedLaden">Loaded</label>
                </div>
                <div class="custom-Radio">
                  <input type="radio" formControlName="IsShipLoaded" id="rbtnIsShipLoadedBallast" value="false" />
                  <label for="rbtnIsShipLoadedBallast">Ballast</label>
                </div>
              </div>
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['IsShipLoaded']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['IsShipLoaded']?.errors?.required">This
                  Field is Required</span>
              </div>
            </div>
            <div class="form-group">

              <label for="txtUserName">Transit agent</label>
              <span class="red"> *</span>
              <div class="ng-autocomplete">
                <ng-autocomplete formControlName="Transitagent" [data]="agentsNamesList" [searchKeyword]="keyword"
                  autocomplete="off" (selected)='selectAgentNameEvent($event)' (inputCleared)="onAgentNameCleared()"
                  (inputChanged)='onAgentsNamesSearchChange($event)' (inputFocused)='onFocused($event)'
                  [itemTemplate]="itemTemplate" [minQueryLength]="autoCompleteMinQueryLength"
                  [notFoundTemplate]="notFoundTemplate" [isLoading]="isAutoCompleteLoading"
                  placeHolder="{{'SHARED.REPORTS.AGENT_NAME_MIN_CHARS' | translate }}">
                </ng-autocomplete>

                <ng-template #itemTemplate let-item>
                  <a [innerHTML]="item"></a>
                </ng-template>

                <ng-template #notFoundTemplate let-notFound>
                  <div [innerHTML]="this.agentNameNotFoundMessage"></div>
                </ng-template>
              </div>
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['Transitagent']?.invalid" class="red">
                <div *ngIf="releaseRequestForm?.controls['TabThree']?.controls['Transitagent']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="txttransitAgentName">Agent Name which will be written on bill</label>
              <span class="red">*</span>
              <input type="text" formControlName="transitAgentName" name="transitAgentName" id="txttransitAgentName"
                class="form-control" />
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['transitAgentName']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['transitAgentName']?.errors?.required">This
                  Field is Required</span>
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['transitAgentName']?.errors?.pattern">Please
                  Enter a Valid Agent Name</span>
              </div>
            </div>
            <div class="form-group">
              <label for="txttransitAgentEMail">Transit Agent Email</label>
              <span class="red">*</span>
              <input type="email" formControlName="TransitagentEmail" name="TransitagentEmail" id="txttransitAgentEMail"
                class="form-control" />
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['TransitagentEmail']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['TransitagentEmail']?.errors?.required">This
                  Field is Required</span>
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['TransitagentEmail']?.errors?.pattern">Please
                  Enter a Valid Email</span>
              </div>

            </div>

            <!-- Fax -->
            <div class="form-group">
              <label for="txtTransitAgentFax">Transit Agent Fax</label>
              <span class="red">*</span>
              <input type="text" formControlName="TransitagentFax" name="TransitagentFax" id="txtTransitAgentFax"
                class="form-control" />
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['TransitagentFax']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['TransitagentFax']?.errors?.pattern">Please
                  Enter a Valid Fax Number</span>
              </div>
            </div>
            <div class="form-group">
              <label for="txtTransitDWT">Transit DWT</label>
              <span class="red"> *</span>
              <input type="text" formControlName="TransitDWT" name="TransitDWT" id="txtTransitDWT" maxlength="6"
                class="form-control" />
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['TransitDWT']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['TransitDWT']?.errors?.required">This
                  Field is Required</span>
              </div>
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['TransitDWT']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['TransitDWT']?.errors?.pattern">DWT
                  must be (1 to 6) digits</span>
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['TransitDWT']?.errors?.maxlength">This
                  Field can be at most 50 characters</span>
              </div>
            </div>
            <!-- SCNT -->
            <div class="form-group">
              <label for="txtTransitSCNT">Transit Net Tonnage (SCNT)</label>
              <span class="red"> *</span>
              <input type="text" formControlName="TransitSCNT" name="TransitSCNT" id="txtTransitSCNT"
                class="form-control" />
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['TransitSCNT']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['TransitSCNT']?.errors?.required">This
                  Field is Required</span>
              </div>
              <div *ngIf="releaseRequestForm?.controls['TabThree']?.controls['TransitSCNT']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['TransitSCNT']?.errors?.pattern">Net
                  Tonnage (SCNT) must be (1 to 6) digits and allows (1 to 2) Decimals</span>
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['TransitSCNT']?.errors?.maxlength">This
                  Field can be at most 50 characters</span>
              </div>
            </div>
            <div class="form-group">
              <label for="txtTransitRebatePercentage">Transit Rebate Percentage</label>
              <span class="red"> *</span>
              <input type="text" formControlName="TransitRebatePercentage" name="TransitRebatePercentage"
                id="txtTransitRebatePercentage" class="form-control" />
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['TransitRebatePercentage']?.invalid" class="red">
                <div
                  *ngIf="releaseRequestForm?.controls['TabThree']?.controls['TransitRebatePercentage']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['TransitRebatePercentage']?.errors?.pattern">This
                  Field allows digits only</span>
              </div>
            </div>
            <div class="form-group">
              <label for="txtActualRebatePercentage">Actual rebate Percentage</label>
              <input type="text" formControlName="ActualRebatePercentage" name="ActualRebatePercentage"
                id="txtActualRebatePercentage" class="form-control" />
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['ActualRebatePercentage']?.invalid" class="red">
                <div
                  *ngIf="releaseRequestForm?.controls['TabThree']?.controls['ActualRebatePercentage']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['ActualRebatePercentage']?.errors?.pattern">This
                  Field allows digits only</span>
              </div>
            </div>
            <div class="form-group">

              <label for="txtRebateAmountAsPerInvoice">Rebate Amount as per invoice</label>

              <input type="text" formControlName="RebateAmountAsPerInvoice" (change)="rebateAmountChanged()"
                name="RebateAmountAsPerInvoice" id="txtRebateAmountAsPerInvoice" class="form-control" />
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['RebateAmountAsPerInvoice']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['RebateAmountAsPerInvoice']?.errors?.required">This
                  Field is Required</span>
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['RebateAmountAsPerInvoice']?.errors?.pattern">This
                  Field allows digits only</span>
              </div>
            </div>
            <div class="form-group">
              <label for="txtActualRebateAmount">Actual Rebate Amount</label>

              <input type="text" formControlName="ActualRebateAmount" (change)="rebateAmountChanged()"
                name="ActualRebateAmount" id="txtActualRebateAmount" class="form-control" />
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['ActualRebateAmount']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['ActualRebateAmount']?.errors?.required">This
                  Field is Required</span>
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['ActualRebateAmount']?.errors?.pattern">This
                  Field allows digits only</span>
              </div>
            </div>
            <div class="form-group">
              <label for="txtDiffAmount">Deference amount to be added or reserved</label>
              <input type="number" formControlName="DiffAmount" name="DiffAmount" id="txtDiffAmount"
                class="form-control" />
            </div>

            <div class="form-group">
              <label for="Currency">Currency</label>
              <span class="red">*</span>

              <select formControlName="Currency" class="form-control" id="Currency" name="Currency">
                <option value="" selected>Choose</option>
                <option *ngFor="let currency of AgentCurrencies" [value]="currency.Id">
                  {{currency.NameEN}}
                </option>
              </select>
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['Currency']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['Currency']?.errors?.required">This
                  Field is Required</span>
              </div>
            </div>

            <div class="form-group">
              <label for="txtInvoiceNo">Invoice no.</label>
              <span class="red">*</span>
              <input type="text" formControlName="InvoiceNo" name="InvoiceNo" id="txtInvoiceNo" class="form-control" />
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['InvoiceNo']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['InvoiceNo']?.errors?.required">This
                  Field is Required</span>
              </div>
            </div>
            <div class="form-group">
              <label>Is Circular</label>
              <span *ngIf="formMode != 3" class="red"> *</span>
              <div>
                <div class="custom-Radio">
                  <input type="radio" formControlName="IsCircular" id="rbtnIsCircular" value="true"
                    (change)="onIsCircularChange($event.target.value)" />
                  <label for="rbtnIsCircular">Yes</label>
                </div>
                <div class="custom-Radio">
                  <input type="radio" formControlName="IsCircular" id="rbtnIsNotCircular" value="false"
                    (change)="onIsCircularChange($event.target.value)" />
                  <label for="rbtnIsNotCircular">No</label>
                </div>
              </div>
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['IsCircular']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['IsCircular']?.errors?.required">This
                  Field is Required</span>
              </div>
            </div>
            <div class="form-group" *ngIf="showCircularName">
              <label for="ddlCircularName">Circular</label>
              <span class="red"> *</span>
              <select (change)="onCircularChange($event.target.value)" formControlName="CircularName"
                class="form-control" id="ddlCircularName" name="CircularName">
                <option value="" selected>Choose</option>
                <option *ngFor="let circular of circulars" [value]="circular?.CircularNo">
                  {{circular?.CircularNo}}
                </option>
              </select>
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['CircularName']?.invalid" class="red">
                <div *ngIf="releaseRequestForm?.controls['TabThree']?.controls['CircularName']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>Is Exception</label>
              <span *ngIf="formMode != 3" class="red"> *</span>
              <div>
                <div class="custom-Radio">
                  <input type="radio" formControlName="IsException" id="rbtnIsException" value="true"
                    (change)="onIsExceptionChange($event.target.value)" />
                  <label for="rbtnIsException">Yes</label>
                </div>
                <div class="custom-Radio">
                  <input type="radio" formControlName="IsException" id="rbtnIsNotException" value="false"
                    (change)="onIsExceptionChange($event.target.value)" />
                  <label for="rbtnIsNotException">No</label>
                </div>
              </div>
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['IsException']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['IsException']?.errors?.required">This
                  Field is Required</span>
              </div>
            </div>
            <div class="form-group" *ngIf="showExceptionNote">
              <label for="txtExceptionNote">Exception Note</label>
              <span class="red">*</span>
              <input type="text" formControlName="ExceptionNote" name="ExceptionNote" id="txtExceptionNote"
                class="form-control" />
              <div *ngIf="isTabThreeSubmitted &&
                releaseRequestForm?.controls['TabThree']?.controls['ExceptionNote']?.invalid" class="red">
                <span *ngIf="releaseRequestForm?.controls['TabThree']?.controls['ExceptionNote']?.errors?.required">This
                  Field is Required</span>
              </div>
            </div>
          </div>
        </div>
        <p class="btns-holder text-right">
          <button type="button" class="btn SCAcustomBtn" (click)="selectTab(1)">{{ 'FRONT_USER.PREVIOUS' |
            translate}}</button>
          <button type="button" class="btn SCAcustomBtn" (click)="selectTab(3) ">{{ 'FRONT_USER.NEXT' |
            translate}}</button>
        </p>
      </tab>
      <tab heading="Voyage Certificates">
        <div formGroupName="TabFour" #TabFour>
          <div class="form-container">
            <div class="form-section">
              <h4 class="section-title">Voyage Certificates</h4>
            </div>
            <div class="form-group">
              <label for="dpDateofLastAgentCorrespondence">Date of last agent correspondence</label>
              <span class="red">*</span>
              <input #FormulateDecisionDateDatepicker="bsDatepicker" bsDatepicker
                formControlName="DateofLastAgentCorrespondence" [minDate]='null'
                [bsConfig]="{dateInputForat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off"
                id="DateofLastAgentCorrespondence" class="form-control" name="DateofLastAgentCorrespondence">
              <div *ngIf="isTabFourSubmitted &&
                releaseRequestForm?.controls['TabFour']?.controls['DateofLastAgentCorrespondence']?.invalid"
                class="red">
                <div
                  *ngIf="releaseRequestForm?.controls['TabFour']?.controls['DateofLastAgentCorrespondence']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="dpDatesOfReceivingLastAgentCorrespondence">Dates of receiving last agent
                correspondence</label>
              <span class="red">*</span>
              <input #FormulateDecisionDateDatepicker="bsDatepicker" bsDatepicker
                formControlName="DatesOfReceivingLastAgentCorrespondence" [minDate]='null'
                [bsConfig]="{dateInputForat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off"
                id="DatesOfReceivingLastAgentCorrespondence" class="form-control"
                name="DatesOfReceivingLastAgentCorrespondence">
              <div *ngIf="isTabFourSubmitted &&
                releaseRequestForm?.controls['TabFour']?.controls['DatesOfReceivingLastAgentCorrespondence']?.invalid"
                class="red">
                <div
                  *ngIf="releaseRequestForm?.controls['TabFour']?.controls['DatesOfReceivingLastAgentCorrespondence']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>
            <!--  <div class="form-group">
            <label for="dpDateOfLastReceivedDocuments">Date of last received documents</label>
            <input #FormulateDecisionDateDatepicker="bsDatepicker" bsDatepicker
              formControlName="DateOfLastReceivedDocuments" [minDate]='null'
              [bsConfig]="{dateInputForat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off"
              id="DateOfLastReceivedDocuments" class="form-control" name="DateOfLastReceivedDocuments">
          </div>-->
            <div class="form-group">
              <label for="txtVoyageCertificatesOriginPort">Origin port</label>
              <span class="red">*</span>
              <input type="text" formControlName="VoyageCertificatesOriginPort" name="VoyageCertificatesOriginPort"
                id="txtVoyageCertificatesOriginPort" class="form-control" />
              <div *ngIf="isTabFourSubmitted &&
                releaseRequestForm?.controls['TabFour']?.controls['VoyageCertificatesOriginPort']?.invalid" class="red">
                <div
                  *ngIf="releaseRequestForm?.controls['TabFour']?.controls['VoyageCertificatesOriginPort']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="dpDocumnetedSailingDate">Sailing date (Documented)</label>
              <span class="red">*</span>
              <input #DocumnetedSailingDateDateDatepicker="bsDatepicker" bsDatepicker
                formControlName="DocumnetedSailingDate" [minDate]='null'
                [bsConfig]="{dateInputForat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off" id="DocumnetedSailingDate"
                class="form-control" name="DocumnetedSailingDate">
              <div *ngIf="isTabFourSubmitted &&
                releaseRequestForm?.controls['TabFour']?.controls['DocumnetedSailingDate']?.invalid" class="red">
                <div
                  *ngIf="releaseRequestForm?.controls['TabFour']?.controls['DocumnetedSailingDate']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="txtVoyageCertificatesDestinationPort">Destination port</label>
              <span class="red">*</span>
              <input type="text" formControlName="VoyageCertificatesDestinationPort"
                name="VoyageCertificatesDestinationPort" id="txtVoyageCertificatesDestinationPort"
                class="form-control" />
              <div *ngIf="isTabFourSubmitted &&
                releaseRequestForm?.controls['TabFour']?.controls['VoyageCertificatesDestinationPort']?.invalid"
                class="red">
                <div
                  *ngIf="releaseRequestForm?.controls['TabFour']?.controls['VoyageCertificatesDestinationPort']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="dpDocumnetedArrivalDate">Arrival date (Documented)</label>
              <span class="red">*</span>
              <input #FormulateDecisionDateDatepicker="bsDatepicker" bsDatepicker
                formControlName="DocumnetedArrivalDate" [minDate]='null'
                [bsConfig]="{dateInputForat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off"
                id="dpDocumnetedArrivalDate" class="form-control" name="DocumnetedArrivalDate">
              <div *ngIf="isTabFourSubmitted &&
                releaseRequestForm?.controls['TabFour']?.controls['DocumnetedArrivalDate']?.invalid" class="red">
                <div
                  *ngIf="releaseRequestForm?.controls['TabFour']?.controls['DocumnetedArrivalDate']?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
              </div>
            </div>
            <div class="form-section">
              <h4 class="section-title">Voyage Stoppage</h4>
            </div>
            <div class="form-container" #TabFourStoppage>

              <div formArrayName="VoyageStoppageDetails">
                <div
                  *ngFor="let VoyageStoppage of releaseRequestForm?.controls['TabFour']?.get('VoyageStoppageDetails')['controls']; let i=index; let last = last"
                  [formGroupName]="i">
                  <div class="form-section">
                    <input type="hidden" formControlName="Id">
                    <div class="form-group">
                      <label for="txtStoppageportname">Stoppage Port Name</label>
                      <input type="text" formControlName="StoppagePortName" name="StoppagePortName"
                        id="txtStoppageportname" class="form-control" />
                    </div>
                    <div class="form-group">
                      <label for="dpDateofStoppageStartDate">Stoppage Start Date</label>
                      <input #StoppageStartDateDatepicker="bsDatepicker" bsDatepicker
                        formControlName="StoppageStartDate" [minDate]='null'
                        [bsConfig]="{dateInputFormat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off"
                        id="dpDateofStoppageStartDate" class="form-control" name="StoppageStartDate">
                    </div>
                    <div class="form-group">
                      <label for="dpDateofStoppageEndDate">Stoppage End Date</label>
                      <input #StoppageEndDateDatepicker="bsDatepicker" bsDatepicker formControlName="StoppageEndDate"
                        [minDate]='null' [bsConfig]="{dateInputFormat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off"
                        id="StoppageEdpDateofStoppageEndDatendDate" class="form-control" name="StoppageEndDate">
                    </div>
                    <div class="form-group">
                      <label for="txtStoppageReason">Stoppage Reason</label>
                      <input type="text" formControlName="StoppageReason" name="StoppageReason" id="txtStoppageReason"
                        class="form-control" />
                    </div>
                    <div class="btns-holder" *ngIf="showdeleteVoyage">
                      <button type="button" class="btn SCAcustomBtn" Confirmation (click)="deleteVoyageStoppage(i)"
                        *ngIf="VoyageStoppageDetailsLength.length >= 1">
                        {{'FRONT_USER.DELETE' | translate }}
                      </button>
                    </div>
                  </div>

                  <!-- <p class="btns-holder text-right">
                <button type="button" class="btn SCAcustomBtn" (click)="addVoyageStoppage()">(+)
                  {{'FRONT_USER.ADD' | translate }}</button>
              </p>-->
                </div>

                <p *ngIf="showAddVoyageStoppage" class="btns-holder text-left">
                  <button type="button" class="btn SCAcustomBtn" (click)="addVoyageStoppage()">(+)
                    {{'FRONT_USER.ADD' | translate }}</button>
                </p>

              </div>
            </div>

          </div>

          <div class="form-container">
            <h4 class="section-title">Attachments</h4>
          </div>
          <div>


            <div formArrayName="DocsAttachments" #DocsAttachments>
              <div
                *ngFor="let attachment of releaseRequestForm?.controls['TabFour']?.get('DocsAttachments')['controls']; let i=index; let last = last"
                [formGroupName]="i">
                <div class="form-container">


                  <div class="form-group">
                    <label for="DocumentName">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.DOCUMENT_NAME' |
                      translate}}</label>
                    <span class="red">*</span>
                    <input type="text" formControlName="DocumentName" class="form-control" id="DocumentName"
                      name="DocumentName" />
                    <div
                      *ngIf=" isTabFourSubmitted || (attachment.get('DocumentName')?.dirty &&  attachment.get('DocumentName')?.errors)"
                      class="red">
                      <div *ngIf="attachment.get('DocumentName')?.errors?.required">
                        {{'FRONT_USER.This_Field_Is_Required'| translate}}
                      </div>

                    </div>
                  </div>


                  <div  *ngIf="showUpload" class="form-group">
                  <!--  <div *ngIf="!AttachmentView" class="form-group">-->
                    <label for="URL">{{'FRONT_USER.FEES_ESTIMATION_FORM.DOCUMENT'| translate}}</label>
                    <span class="red"> *</span>

                    <input type="file"
                      accept=".pdf,.PDF, .gif,.GIF, .jpg,.JPG, .jpeg,.JPEG, .png,.PNG, .bmp,.BMP, .doc,.DOC, .docx,.DOCX"
                      MaxSizeInMB="5" class="form-control" id="URL" formControlName="URL"
                      (change)="onFileSelected($event,attachment.get('URL'),i,'DdocumentsProgress'+i,'D')" />
                    <div class="upload-info">
                      <span data-toggle="tooltip"
                        title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle'
                        | translate}}</span>
                      <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
                    </div>
                    <div class="progress">
                      <div *ngIf="i==0" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                        aria-valuemax="100" [style.width]="DdocumentsProgress0+'%'">

                        <span class=""> {{ DdocumentsProgress0 }} % Complete</span>
                      </div>
                      <div *ngIf="i==1" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                        aria-valuemax="100" [style.width]="DdocumentsProgress1+'%'">

                        <span class=""> {{ DdocumentsProgress1 }} % Complete</span>
                      </div>
                      <div *ngIf="i==2" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                        aria-valuemax="100" [style.width]="DdocumentsProgress2+'%'">

                        <span class=""> {{ DdocumentsProgress2 }} % Complete</span>
                      </div>
                      <div *ngIf="i==3" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                        aria-valuemax="100" [style.width]="DdocumentsProgress3+'%'">

                        <span class=""> {{ DdocumentsProgress3 }} % Complete</span>
                      </div>
                      <div *ngIf="i==4" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                        aria-valuemax="100" [style.width]="DdocumentsProgress4+'%'">

                        <span class=""> {{ DdocumentsProgress4 }} % Complete</span>
                      </div>
                      <div *ngIf="i==5" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                        aria-valuemax="100" [style.width]="DdocumentsProgress5+'%'">

                        <span class=""> {{ DdocumentsProgress5 }} % Complete</span>
                      </div>
                      <div *ngIf="i==6" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                        aria-valuemax="100" [style.width]="DdocumentsProgress6+'%'">

                        <span class=""> {{ DdocumentsProgress6 }} % Complete</span>
                      </div>
                      <div *ngIf="i==7" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                        aria-valuemax="100" [style.width]="DdocumentsProgress7+'%'">

                        <span class=""> {{ DdocumentsProgress7 }} % Complete</span>
                      </div>
                      <div *ngIf="i==8" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                        aria-valuemax="100" [style.width]="DdocumentsProgress8+'%'">

                        <span class=""> {{ DdocumentsProgress8 }} % Complete</span>
                      </div>
                      <div *ngIf="i==9" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                        aria-valuemax="100" [style.width]="DdocumentsProgress9+'%'">

                        <span class=""> {{ DdocumentsProgress9 }} % Complete</span>
                      </div>
                    </div>


                    <div *ngIf=" isTabFourSubmitted || (attachment.get('URL')?.dirty &&  attachment.get('URL')?.errors)"
                      class="red">
                      <div *ngIf="attachment.get('URL')?.errors?.required">
                        {{'FRONT_USER.This_Field_Is_Required'| translate}}
                      </div>
                      <div *ngIf="attachment.get('URL').errors?.notCompleted">
                        {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                      </div>
                    </div>
                  </div>

                  <div class="form-group read-uploaded"*ngIf="AttachmentView && DocsAttachment[i]?.URL">
                    <label>{{'FRONT_USER.FEES_ESTIMATION_FORM.DOCUMENT'|translate}}</label>

                    <a [attr.href]="uploadUrl+uploadFolder+'/'+DocsAttachment[i]?.URL" target="_blank">
                      <i class="icon-view-file"></i>
                      {{DocsAttachment[i]?.DocumentName}}
                    </a>
                  </div>
                  <input type="hidden" formControlName="AttachmentTypeId" [ngModel]="DocsAttachmentType">

                  <!--<p *ngIf="showDelete">-->
                  <p>
                    <button type="button" class="btn SCAcustomBtn" Confirmation
                      (confirmationClick)="deleteDocsAttachments(i,'DdocumentsProgress'+i)"
                      *ngIf="getAttachmentsLengthGetter >= 1 && showDelete ">
                      {{'FRONT_USER.DELETE' | translate }}
                    </button>
                  </p>

                </div>
                <!-- *ngIf="!(i>8) && last" this condition for the agent can add up to 10 documents  -->


              </div>
              <p *ngIf="showAddAttachment" class="btns-holder text-left">
                <button type="button" class="btn SCAcustomBtn" (click)="addDocsAttachments()">(+)
                  {{'FRONT_USER.ADD' | translate }}</button>
              </p>
            </div>
          </div>
        </div>

        <p class="btns-holder text-right">
          <button type="button" class="btn SCAcustomBtn" (click)="selectTab(2)">{{ 'FRONT_USER.PREVIOUS' |
            translate}}</button>
          <button type="button" class="btn SCAcustomBtn" (click)="selectTab(4) ">{{ 'FRONT_USER.NEXT' |
            translate}}</button>
        </p>

      </tab>
      <tab heading="Voyage Records AIS">
        <div formGroupName="TabFive" #TabFive>
          <div class="form-container">
          <div class="form-section">
            <h4 class="section-title">Voyage Records AIS</h4>
          </div>
          <div class="form-group">
            <label for="txtAISOriginPort">Origin port</label>
            <span class="red">*</span>
            <input type="text" formControlName="AISOriginPort" name="AISOriginPort" id="txtAISOriginPort"
              class="form-control" />
            <div *ngIf="isTabFiveSubmitted &&
              releaseRequestForm?.controls['TabFive']?.controls['AISOriginPort']?.invalid" class="red">
              <div *ngIf="releaseRequestForm?.controls['TabFive']?.controls['AISOriginPort']?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="dpAISSailingDate">Sailing date (AIS)</label>
            <span class="red">*</span>
            <input #AISSailingDateDateDatepicker="bsDatepicker" bsDatepicker formControlName="AISSailingDate"
              [minDate]='null' [bsConfig]="{dateInputForat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off"
              id="AISSailingDate" class="form-control" name="AISSailingDate">
            <div *ngIf="isTabFiveSubmitted &&
              releaseRequestForm?.controls['TabFive']?.controls['AISSailingDate']?.invalid" class="red">
              <div *ngIf="releaseRequestForm?.controls['TabFive']?.controls['AISSailingDate']?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="txtAISDestinationPort">Destination port</label>
            <span class="red">*</span>
            <input type="text" formControlName="AISDestinationPort" name="AISDestinationPort" id="txtAISDestinationPort"
              class="form-control" />
            <div *ngIf="isTabFiveSubmitted &&
              releaseRequestForm?.controls['TabFive']?.controls['AISDestinationPort']?.invalid" class="red">
              <div *ngIf="releaseRequestForm?.controls['TabFive']?.controls['AISDestinationPort']?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="dpAISArrivalDate">Arrival date (AIS)</label>
            <span class="red">*</span>
            <input #AISArrivalDateDatepicker="bsDatepicker" bsDatepicker formControlName="AISArrivalDate"
              [minDate]='null' [bsConfig]="{dateInputForat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off"
              id="dpAISArrivalDate" class="form-control" name="AISArrivalDate">
            <div *ngIf="isTabFiveSubmitted &&
              releaseRequestForm?.controls['TabFive']?.controls['AISArrivalDate']?.invalid" class="red">
              <div *ngIf="releaseRequestForm?.controls['TabFive']?.controls['AISArrivalDate']?.errors?.required">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="Remarks">Remarks</label>
            <textarea name="Remarks" id="Remarks" name="Remarks" formControlName="Remarks"
              class="form-control"></textarea>
          </div>
          <div class="form-section">
            <h4 class="section-title">Voyage Stoppage</h4>
          </div>
          <div class="form-container" #TabFiveStoppage>
            <div formArrayName="AISVoyageStoppageDetails">
              <div
                *ngFor="let AISVoyageStoppage of releaseRequestForm?.controls['TabFive']?.get('AISVoyageStoppageDetails')['controls']; let i=index; let last = last"
                [formGroupName]="i">

                <div class="form-section">
                  <input type="hidden" formControlName="Id">
                  <div class="form-group">
                    <label for="txtStoppageportname">Stoppage Port Name</label>
                    <input type="text" formControlName="AISStoppagePortName" name="AISStoppagePortName"
                      id="txtStoppageportname" class="form-control" />
                  </div>
                  <div class="form-group">
                    <label for="dpDateofStoppageStartDate">Stoppage Start Date</label>
                    <input #StoppageStartDateDatepicker="bsDatepicker" bsDatepicker
                      formControlName="AISStoppageStartDate" [minDate]='null'
                      [bsConfig]="{dateInputFormat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off"
                      id="dpDateofStoppageStartDate" class="form-control" name="AISStoppageStartDate">
                  </div>
                  <div class="form-group">
                    <label for="dpDateofStoppageEndDate">Stoppage End Date</label>
                    <input #StoppageEndDateDatepicker="bsDatepicker" bsDatepicker formControlName="AISStoppageEndDate"
                      [minDate]='null' [bsConfig]="{dateInputFormat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off"
                      id="dpDateofStoppageEndDate" class="form-control" name="AISStoppageEndDate">
                  </div>

                  <div class="btns-holder"*ngIf="showdeleteVoyage">
                    <button type="button" class="btn SCAcustomBtn" Confirmation (click)="AISdeleteVoyageStoppage(i)"
                      *ngIf="AISVoyageStoppageDetailsLength.length >= 1">
                      {{'FRONT_USER.DELETE' | translate }}
                    </button>
                  </div>
                </div>


              </div>

              <p *ngIf="showAddAISVoyageStoppage" class="btns-holder text-left">
                <button type="button" class="btn SCAcustomBtn" (click)="AISaddVoyageStoppage()">(+)
                  {{'FRONT_USER.ADD' | translate }}</button>
              </p>
            </div>
          </div>
        </div>

        <div class="form-container">
          <h4 class="section-title">Attachments</h4>
        </div>
        <div>



          <div formArrayName="AISAttachments" #AISAttachments>
            <div
              *ngFor="let attachment of releaseRequestForm?.controls['TabFive']?.get('AISAttachments')['controls']; let i=index; let last = last"
              [formGroupName]="i">
              <div class="form-container">


                <div class="form-group">
                  <label for="DocumentName">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.DOCUMENT_NAME' |
                    translate}}</label>
                  <span class="red">*</span>
                  <input type="text" formControlName="DocumentName" class="form-control" id="DocumentName"
                    name="DocumentName" />
                  <div
                    *ngIf=" isTabFiveSubmitted || (attachment.get('DocumentName')?.dirty &&  attachment.get('DocumentName')?.errors)"
                    class="red">
                    <div *ngIf="attachment.get('DocumentName')?.errors?.required">
                      {{'FRONT_USER.This_Field_Is_Required'| translate}}
                    </div>

                  </div>
                </div>


                <div *ngIf="showUpload" class="form-group">
                  <label for="URL">{{'FRONT_USER.FEES_ESTIMATION_FORM.DOCUMENT'| translate}}</label>
                  <span class="red"> *</span>

                  <input type="file"
                    accept=".pdf,.PDF, .gif,.GIF, .jpg,.JPG, .jpeg,.JPEG, .png,.PNG, .bmp,.BMP, .doc,.DOC, .docx,.DOCX"
                    MaxSizeInMB="5" class="form-control" id="URL" formControlName="URL"
                    (change)="onFileSelected($event,attachment.get('URL'),i,'AdocumentsProgress'+i,'A')" />
                  <div class="upload-info">
                    <span data-toggle="tooltip"
                      title="{{'FRONT_USER.REPAIR_REQUEST_FORM.DRAWING_ALLOWED_EXTENTIONS' | translate}}">{{'FRONT_USER.AllowedFileExtentionsTitle'
                      | translate}}</span>
                    <span>{{'FRONT_USER.MaxFileSizeTitle' | translate}}</span>
                  </div>
                  <div class="progress">
                    <div *ngIf="i==0" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="AdocumentsProgress0+'%'">

                      <span class=""> {{ AdocumentsProgress0 }} % Complete</span>
                    </div>
                    <div *ngIf="i==1" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="AdocumentsProgress1+'%'">

                      <span class=""> {{ AdocumentsProgress1 }} % Complete</span>
                    </div>
                    <div *ngIf="i==2" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="AdocumentsProgress2+'%'">

                      <span class=""> {{ AdocumentsProgress2 }} % Complete</span>
                    </div>
                    <div *ngIf="i==3" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="AdocumentsProgress3+'%'">

                      <span class=""> {{ AdocumentsProgress3 }} % Complete</span>
                    </div>
                    <div *ngIf="i==4" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="AdocumentsProgress4+'%'">

                      <span class=""> {{ AdocumentsProgress4 }} % Complete</span>
                    </div>
                    <div *ngIf="i==5" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="AdocumentsProgress5+'%'">

                      <span class=""> {{ AdocumentsProgress5 }} % Complete</span>
                    </div>
                    <div *ngIf="i==6" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="AdocumentsProgress6+'%'">

                      <span class=""> {{ AdocumentsProgress6 }} % Complete</span>
                    </div>
                    <div *ngIf="i==7" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="AdocumentsProgress7+'%'">

                      <span class=""> {{ AdocumentsProgress7 }} % Complete</span>
                    </div>
                    <div *ngIf="i==8" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="AdocumentsProgress8+'%'">

                      <span class=""> {{ AdocumentsProgress8 }} % Complete</span>
                    </div>
                    <div *ngIf="i==9" class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0"
                      aria-valuemax="100" [style.width]="AdocumentsProgress9+'%'">

                      <span class=""> {{ AdocumentsProgress9 }} % Complete</span>
                    </div>
                  </div>


                  <div *ngIf=" isTabFiveSubmitted || (attachment.get('URL')?.dirty &&  attachment.get('URL')?.errors)"
                    class="red">
                    <div *ngIf="attachment.get('URL')?.errors?.required">
                      {{'FRONT_USER.This_Field_Is_Required'| translate}}
                    </div>
                    <div *ngIf="attachment.get('URL').errors?.notCompleted">
                      {{'FRONT_USER.FILE_NOT_COMPELETED' | translate}}
                    </div>
                  </div>
                </div>

                <div class="form-group read-uploaded" *ngIf="AttachmentView && AISAttachment[i]?.URL" >
                  <label>{{'FRONT_USER.FEES_ESTIMATION_FORM.DOCUMENT'|translate}}</label>

                  <a [attr.href]="uploadUrl+uploadFolder+'/'+AISAttachment[i]?.URL" target="_blank">
                    <i class="icon-view-file"></i>
                    {{AISAttachment[i]?.DocumentName}}
                  </a>
                </div>
                <input type="hidden" formControlName="AttachmentTypeId" [ngModel]="AISAttachmentType">

                <p>
                  <button type="button" class="btn SCAcustomBtn" Confirmation
                    (confirmationClick)="deleteAISAttachments(i,'AdocumentsProgress'+i)"
                    *ngIf="getAISAttachmentsLengthGetter >= 1 && showDelete">
                    {{'FRONT_USER.DELETE' | translate }}
                  </button>
                </p>

              </div>
              <!-- *ngIf="!(i>8) && last" this condition for the agent can add up to 10 documents  -->


            </div>
            <p *ngIf="showAddAttachment" class="btns-holder text-left">
              <button type="button" class="btn SCAcustomBtn" (click)="addAISAttachments()">(+)
                {{'FRONT_USER.ADD' | translate }}</button>
            </p>
          </div>
        </div>
        </div>

        <p class="btns-holder text-right">
          <button type="button" class="btn SCAcustomBtn" (click)="selectTab(5)">{{ 'FRONT_USER.PREVIOUS' |
            translate}}</button>
          <button type="button" class="btn SCAcustomBtn" (click)="selectTab(3) ">{{ 'FRONT_USER.NEXT' |
            translate}}</button>
        </p>

      </tab>
      <tab heading="Economic Unit Data" *ngIf="showTabSix">
        <div class="form-container" formGroupName="TabSix" #TabSix>
          <div class="form-section">
            <h4 class="section-title">Economic Unit Data</h4>
          </div>
          <div class="form-group">
            <label for="txtVesselName">Vessel Name</label>
            <input type="text" formControlName="VesselName" name="VesselName" id="txtVesselName"
              class="form-control text-uppercase" />
          </div>

          <div class="form-group">
            <label for="txtRebateFileNo">Rebate file no.</label>
            <input type="text" formControlName="RebateFileNumber" name="RebateFileNumber" id="txtRebateFileNo"
              class="form-control text-uppercase" />
          </div>
          <div class="form-group">
            <label for="textCreateddate">Creation date</label>

            <input type="text" #CreationDateDatepicker="bsDatepicker" bsDatepicker [minDate]='null'
              [bsConfig]="{dateInputForat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off"
              formControlName="BaseRequestCreationDate" name="BaseRequestCreationDate" id="textCreateddate"
              class="form-control text-uppercase" />
          </div>
          <div class="form-group">
            <label for="dpDocumnetedSailingDate">Sailing date (Documented)</label>
            <input #DocumnetedSailingDateDateDatepicker="bsDatepicker" bsDatepicker
              formControlName="DocumnetedSailingDate" [minDate]='null'
              [bsConfig]="{dateInputForat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off" id="DocumnetedSailingDate"
              class="form-control" name="DocumnetedSailingDate">
          </div>
          <div class="form-group">
            <label for="dpTransitDate"> Transit Date</label>
            <input #TransitDateDatepicker="bsDatepicker" bsDatepicker formControlName="TransitDate" [minDate]='null'
              [bsConfig]="{dateInputForat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off" id="dpTransitDate"
              class="form-control" name="TransitDate" />
          </div>
          <div class="form-group">
            <label for="dpDatesOfReceivingLastAgentCorrespondence">Dates of receiving last agent correspondence</label>
            <input #FormulateDecisionDateDatepicker="bsDatepicker" bsDatepicker
              formControlName="DatesOfReceivingLastAgentCorrespondence" [minDate]='null'
              [bsConfig]="{dateInputForat: 'YYYY-MM-DD', minMode: hour}" autocomplete="off"
              id="DatesOfReceivingLastAgentCorrespondence" class="form-control"
              name="DatesOfReceivingLastAgentCorrespondence">
          </div>
          <div class="form-group">
            <label for="txtVoyageCertificatesOriginPort">Origin port</label>
            <input type="text" formControlName="VoyageCertificatesOriginPort" name="VoyageCertificatesOriginPort"
              id="txtVoyageCertificatesOriginPort" class="form-control" />
          </div>
          <div class="form-group">
            <label for="txtVoyageCertificatesDestinationPort">Destination port</label>
            <input type="text" formControlName="VoyageCertificatesDestinationPort"
              name="VoyageCertificatesDestinationPort" id="txtVoyageCertificatesDestinationPort" class="form-control" />
          </div>
          <div class="form-group">
            <label for="txtTransitRebatePercentage">Transit Rebate Percentage</label>
            <input type="text" formControlName="TransitRebatePercentage" name="TransitRebatePercentage"
              id="txtTransitRebatePercentage" class="form-control" />
          </div>
          <div class="form-group">

            <label for="txtRebateAmountAsPerInvoice">Rebate Amount as per invoice</label>

            <input type="text" formControlName="RebateAmountAsPerInvoice" name="RebateAmountAsPerInvoice"
              id="txtRebateAmountAsPerInvoice" class="form-control" />
          </div>
          <div class="form-group">
            <label for="txttransitAgentName">Agent Name</label>
            <span class="red">*</span>
            <input type="text" formControlName="transitAgentName" name="transitAgentName" id="txttransitAgentName"
              class="form-control" />
          </div>
          <div class="form-group">
            <label>Is Exception</label>
            <div>
              <div class="custom-Radio">
                <input type="radio" formControlName="IsException" id="rbtnIsException" value="true" />
                <label for="rbtnIsException">Yes</label>
              </div>
              <div class="custom-Radio">
                <input type="radio" formControlName="IsException" id="rbtnIsNotException" value="false" />
                <label for="rbtnIsNotException">No</label>
              </div>
            </div>
          </div>









        </div>

        <p class="btns-holder text-right">
          <button type="button" class="btn SCAcustomBtn" (click)="selectTab(4)">{{ 'FRONT_USER.PREVIOUS' |
            translate}}</button>

        </p>
      </tab>
    </tabset>
  </form>
  <p class="form-group" *ngIf="showValidateBtn">
    <button type="button" *ngIf="showSaveBtn" (click)="Save()" class="btn SCAcustomBtn">Save</button>
    <button type="button" id="ValidateBTN" (click)="Calculate()" class="btn SCAcustomBtn">Validate</button>
  </p>
  <p class="form-group" *ngIf="showSubmitWorkflowBtn">
    <button type="button" id="submitWFBtn" (click)="SubmitWorkflow()" class="btn SCAcustomBtn">Submit</button>
  </p>
  <div *ngIf="diffsObjects.length > 0 && showInfo " class="read-only-content">

    <div class="form-container">
      <h4 class="section-title">Validation notes</h4>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered table-striped table-services">
        <thead>
          <tr>
            <th *ngIf="showReasonCol"><span></span></th>
            <th><span>Field</span></th>
            <th><span>Formula</span></th>
            <th><span>Actual</span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let diff of diffsObjects; let i = index;">
            <td *ngIf="showReasonCol">
              <input type="checkbox" name="group1" (change)="onRowSelect($event, diff)" />
            </td>
            <td>{{diff.Field}}</td>
            <td>{{diff.Formula}}</td>
            <td>{{diff.NewData}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
<div *ngIf="(isRefundWorkflow || isRestudyWorkflow)  && !isFormValid && showInfo">
  <div class="form-container">
    <form name="noteAndReasons" [formGroup]="noteAndReasons" style="width:100%;">
      <div class="form-section">
        <h4 class="section-title">Notes</h4>
        <div class="form-group" *ngIf="showReason">
          <label for="Reason">Reason</label>
          <span class="red"> *</span>
          <textarea name="Reason" id="Reason" name="Reason" formControlName="Reason" class="form-control"></textarea>
          <div *ngIf="isFormSubmitted && Validate2.Reason?.errors" class="red">
            <div *ngIf="Validate2.Reason?.errors?.required">
              {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
          </div>
        </div>
        <div class="form-group">
          <label for="Notes">Note</label>
          <textarea name="Note" id="Note" name="Note" formControlName="Note" class="form-control"></textarea>
        </div>
      </div>
    </form>
  </div>

</div>

<!-- Restudy Signed Admins -->
<div *ngIf="isRestudyWorkflow && !isFormValid">
  <app-release-wf-submitted-admins [requestId]="restudyRequestId" [workflowName]="'Restudy'">
  </app-release-wf-submitted-admins>
</div>

<!-- Refund Signed Admins -->
<div *ngIf="isRefundWorkflow && !isFormValid">
  <app-release-wf-submitted-admins [requestId]="refundRequestId" [workflowName]="'Refund'">
  </app-release-wf-submitted-admins>
</div>



<div *ngIf="isSubmitted && !isFormValid && !isRefundWorkflow && !isRestudyWorkflow">
  <div class="form-container">
    <form name="initiateworkflowForm" [formGroup]="initiateworkflowForm" style="width:100%;">
      <div class="form-section">
        <h4 class="section-title">Admin Decision - initiate workflow</h4>
        <div class="form-group">
          <label>Decision</label>
          <span class="red"> *</span>
          <div class="form-custom-inputs">
            <div class="custom-Radio">
              <input type="radio" id="Refund" formControlName="selectinitiateworkflow" name="selectinitiateworkflow"
                value="1" (change)="OnInitiateWorkflow()" required />
              <label for="Refund">Refund WF</label>
            </div>
            <div class="custom-Radio">
              <input type="radio" id="Restudy" formControlName="selectinitiateworkflow" name="selectinitiateworkflow"
                value="2" (change)="OnInitiateWorkflow()" required />
              <label for="Restudy">Restudy WF</label>
            </div>
          </div>
          <div class="red">
            <span *ngIf="RebateReviewDecision?.errors?.required">This Field is Required</span>
          </div>
        </div>
        <div class="form-group" *ngIf="showML">
          <label for="admins">Assign To Admin(s)</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <ng-multiselect-dropdown id="admins" [formControl]="Validate['Admins']" placeholder="Assign To"
            [settings]="adminsDropdownSettings" [data]="ListOfAdmins" (onDropDownClose)="listChanged()">
          </ng-multiselect-dropdown>

          <div *ngIf="isFormSubmitted && Validate.Admins?.errors" class="red">
            <div *ngIf="Validate.Admins?.errors?.required">
              {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
          </div>
        </div>
        <div class="form-section">
          <div class="form-group" *ngIf="showML && showReason">
            <label for="Reason">Reason</label>
            <span class="red" *ngIf="formMode != 2"> *</span>
            <textarea name="Reason" id="Reason" name="Reason" formControlName="Reason" class="form-control"></textarea>

            <div *ngIf="isFormSubmitted && Validate.Reason?.errors" class="red">
              <div *ngIf="Validate.Reason?.errors?.required">
                {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
            </div>
          </div>

          <div class="form-group" *ngIf="showML">
            <label for="Notes">Note</label>

            <textarea name="Note" id="Note" name="Note" formControlName="Note" class="form-control"></textarea>
          </div>

        </div>
      </div>
    </form>

    <div *ngIf="isSubmitButtonDisplayed" class="form-group">
      <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="submit()">Submit</button>
      <button type="button" class="btn SCAcustomBtn" (click)="later()">Later</button>
    </div>
  </div>
</div>
<div *ngIf="isSubmitted && !isFormValid && (isRefundWorkflow || isRestudyWorkflow)">
  <div class="form-container">

    <form name="WorkflowActionForm" [formGroup]="WorkflowActionForm" style="width:100%;">
      <div class="form-section">
        <h4 class="section-title">Admin Decision</h4>
        <div class="form-group">
          <label>Decision</label>
          <span class="red"> *</span>
          <div class="form-custom-inputs">
            <div class="custom-Radio" *ngIf="isRefundWorkflow">
              <input type="radio" id="Refund" formControlName="workflowDecision" name="workflowDecision" value="1"
                (change)="OnWorkflowDecision()" required />
              <label for="Refund">Continue Refund WF</label>
            </div>
            <div class="custom-Radio" *ngIf="isRefundWorkflow">
              <input type="radio" id="Restudy" formControlName="workflowDecision" name="workflowDecision" value="2"
                (change)="OnWorkflowDecision()" required />
              <label for="Restudy">Start New Restudy WF</label>
            </div>
            <div class="custom-Radio" *ngIf="isRestudyWorkflow">
              <input type="radio" id="Refund" formControlName="workflowDecision" name="workflowDecision" value="3"
                (change)="OnWorkflowDecision()" required />
              <label for="Refund">Continue Restudy WF</label>
            </div>
            <div class="custom-Radio" *ngIf="isRestudyWorkflow">
              <input type="radio" id="Restudy" formControlName="workflowDecision" name="workflowDecision" value="4"
                (change)="OnWorkflowDecision()" required />
              <label for="Restudy">Start New Refund WF</label>
            </div>
          </div>
          <div class="red">
            <span *ngIf="RebateReviewDecision?.errors?.required">This Field is Required</span>
          </div>
        </div>
        <div class="form-group" *ngIf="showML">
          <label for="admins">Assign To Admin(s)</label>
          <span class="red" *ngIf="formMode != 2"> *</span>
          <ng-multiselect-dropdown id="admins" [formControl]="workflowActionForm['Admins']" placeholder="Assign To"
            [settings]="adminsDropdownSettings" [data]="ListOfAdmins" (onDropDownClose)="listChanged()">
          </ng-multiselect-dropdown>

          <div *ngIf="isFormSubmitted && workflowActionForm.Admins?.errors" class="red">
            <div *ngIf="workflowActionForm.Admins?.errors?.required">
              {{ 'FRONT_USER.This_Field_Is_Required' | translate }}</div>
          </div>
        </div>
      </div>
    </form>

    <div *ngIf="isWFSubmitButtonDisplayed" class="form-group">
      <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="SubmitWorkflow()">Submit</button>
    </div>
  </div>
</div>

<div *ngIf="isFormValid && submitConfirmationMode == 1 && !Error" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>You have submitted New Release Form Successfully</p>
    <p>Go Back to <a routerLink="/ReleaseTasks">Release Tasks</a></p>
  </div>
</div>
<!-- Warning -->
<div *ngIf="isFormValid && submitConfirmationMode == 3" class="alert alert-warning" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>This task was submitted before</p>
    <p>Go Back to <a routerLink="/ReleaseTasks">Release Tasks</a></p>
  </div>
</div>
<!-- Error -->
<div *ngIf="isFormValid && submitConfirmationMode == 2 && Error" class="alert alert-danger" role="alert">
  <div class="alignC">
    <i class="icon-error"></i>
    <p>Something went wrong, Please contact System Administrator</p>
    <hr>
    <p>Go Back to <a routerLink="/workspace">Workspace</a></p>
  </div>
</div>
<!-- Workflow Continue Success -->
<div *ngIf="isFormValid && submitConfirmationMode == 4" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>You have submitted the required information to Release Form Successfully</p>
    <p>Go Back to <a routerLink="/ReleaseTasks">Release Tasks</a></p>
  </div>
</div>
<!-- Workflow Recreation Success -->
<div *ngIf="isFormValid && submitConfirmationMode == 5" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <div *ngIf="isRestudyWorkflow">
      <p>The Restudy Workflow has been terminated and a new Refund Workflow has been created Successfully</p>
    </div>
    <div *ngIf="isrefundWorkflow">
      <p>The Refund Workflow has been terminated and a new Restudy Workflow has been created Successfully</p>
    </div>
    <p>Go Back to <a routerLink="/ReleaseTasks">Release Tasks</a></p>
  </div>
</div>
